// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const BasicPlanPageLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-basicplanpage" */ "./BasicPlanPage")).then((bundle)=>{
        return {
            default: bundle.BasicPlanPage
        };
    });
export const LazyBasicPlanPage = /*#__PURE__*/ lazy(BasicPlanPageLazyLoader);
